// Finnish VAT (ALV) rates for transport services
export const VatRates = [
    0.0, // No VAT
    10.0, // Reduced rate
    13.5, // New reduced rate (effective 2026)
    14.0, // Reduced rate
    24.0, // Standard rate
    25.5 // Special rate
];

export const VatRatesMixin = {
    data() {
        return {
            vatRates: VatRates
        };
    }
};
